<template>
  <list-template :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo tổng hợp theo dõi chỉ đạo
              </h3>
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view wrapper-content__main">
        <el-form
          ref="form"
          :model="form"
          label-width="150px"
        >
          <el-form-item label="Thời gian chỉ đạo">
            <el-date-picker
              v-model="commandsDateRange"
              type="daterange"
              format="dd/MM/yyyy"
              class="input-border__bottom input-border__radius__0"
              :picker-options="dateQuickFilterOption"
              range-separator="_"
              start-placeholder="_"
              end-placeholder="_"
              align="right"
              clearable
              @change="commandsDateRangeChanged"
              size="medium"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Hạn hoàn thành">
            <el-date-picker
              v-model="deadlineRange"
              type="daterange"
              format="dd/MM/yyyy"
              class="input-border__bottom input-border__radius__0"
              :picker-options="dateQuickFilterOption"
              range-separator="_"
              start-placeholder="_"
              end-placeholder="_"
              align="right"
              @change="deadlineRangeChanged"
              size="medium"
              clearable
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Lĩnh vực">
            <el-select
              class="width__50 input-border__bottom input-border__radius__0"
              v-model="form.sectors"
              placeholder="Lĩnh vực"
              size="medium"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="item in sectors"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Lãnh đạo chỉ đạo">
            <el-select
              class="width__50 input-border__bottom input-border__radius__0"
              v-model="form.directiveIds"
              placeholder="Lãnh đạo phụ trách"
              size="medium"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="item in listDirectives"
                :key="item.id"
                :label="`${item.fullName} - ${item.positionName}`"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Lãnh đạo phụ trách">
            <el-select
              class="width__50 input-border__bottom input-border__radius__0"
              v-model="form.performIds"
              placeholder="Lãnh đạo phụ trách"
              size="medium"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="item in listDirectives"
                :key="item.id"
                :label="`${item.fullName} - ${item.positionName}`"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Trạng thái">
            <el-select
              class="width__50 input-border__bottom input-border__radius__0"
              v-model="form.commandStatusList"
              placeholder="Trạng thái"
              size="medium"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="item in commandStatusSelectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Đánh giá tiến độ">
            <el-select
              class="width__50 input-border__bottom input-border__radius__0"
              v-model="form.progressStatus"
              placeholder="Trạng thái"
              size="medium"
              filterable
              clearable
            >
              <el-option
                v-for="item in progressStatusSelectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              class="btnSolid__blue"
              size="medium"
              @click="exportReportExcel"
            >
              <i class="fa fa-file-excel" aria-hidden="true"></i>
              &nbsp;Xuất Excel
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from "../../common/list";
import MainHeader from "../../../components/header/main-header";
import utils from "../../../services/utils";
import constants from "../../../constants";
import SubHeader from "../../../components/main/sub-header";
import dateFormatter from "../../../filters/dateFormatter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import hcFlowService from "../../../services/hcFlowService";

export default {
  name: "hc-commands-chi-tiet-report-index",
  components: {
    SubHeader,
    MainHeader,
    ListTemplate
  },

  filters: { dateFormatter },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      form: {
        fromDeadline: null,
        toDeadline: null,
        fromCommandsDate: null,
        toCommandsDate: null,
        directiveIds: null,
        performIds: null,
        sectors: null,
        commandStatusList: null,
        progressStatus: null
      },
      departments: null,
      reportResult: null,
      deadlineRange: null,
      commandsDateRange: null,
      dateQuickFilterOption: null,
      listDirectives: null,
      sectors: null,
      commandStatusSelectOptions: null,
      progressStatusSelectOptions: null,
      hcFlow: null
    };
  },

  watch: {
    reportResult(newValue) {
      if (this.$refs.reportTable)
        this.$refs.reportTable.renderTable({ reportResult: newValue });
    }
  },

  created() {
    if (!this.userDeptRole) return;
    this.initSelectOptions();
    this.initDateQuickFilterOption();
    this.initQuery();
    this.loadHcFlow().then(() => {
      this.loadDirectiveActors();
    });
  },

  methods: {
    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternativeForHcCommands()
        .then(response => (this.hcFlow = response.data));
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcCommands(this.hcFlow.deptId)
        .then(response => (this.listDirectives = response.data));
    },

    initSelectOptions() {
      // this.sectors = hanhChinhUtils.buildHcCommandSectorOptions();
      hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));
      this.commandStatusSelectOptions = hanhChinhUtils.buildHcCommandStatusOptions();
      this.progressStatusSelectOptions = this.buildProgressStatusOptions();
    },

    buildProgressStatusOptions() {
      return [
        {
          id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.DUNG_TIEN_DO,
          name: "Đúng tiến độ"
        },
        { id: constants.HC_CASE_COMMANDS.PROGRESS_STATUS.CHAM, name: "Chậm" }
      ];
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    commandsDateRangeChanged() {
      utils.timeRangeChanged(this.commandsDateRange, (from, to) => {
        this.form.fromCommandsDate = from;
        this.form.toCommandsDate = to;
      });
    },

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from, to) => {
        this.form.fromDeadline = from;
        this.form.toDeadline = to;
      });
    },

    initQuery() {
      let query = this.$route.query;
      this.form.fromDeadline = utils.getIntParamsFromQuery(
        query,
        "fromDeadline"
      );
      this.form.toDeadline = utils.getIntParamsFromQuery(query, "toDeadline");
      this.form.fromCommandsDate = utils.getIntParamsFromQuery(
        query,
        "fromCommandsDate"
      );
      this.form.toCommandsDate = utils.getIntParamsFromQuery(
        query,
        "toCommandsDate"
      );
      this.form.directiveIds = utils.getArrayParamFromQuery(
        query,
        "directiveIds"
      );
      this.form.performIds = utils.getArrayParamFromQuery(query, "performIds");
      this.form.sectors = utils.getArrayParamFromQuery(query, "sectors");
      this.form.commandStatusList = utils.getArrayParamFromQuery(
        query,
        "commandStatusList"
      );
      this.form.progressStatus = utils.getParamFromQuery(
        query,
        "progressStatus"
      );
      this.initDeadlineRange();
      this.initCommandsDateRange();
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
        this.form.fromDeadline,
        this.form.toDeadline
      );
    },

    initCommandsDateRange() {
      this.commandsDateRange = utils.initTimeRange(
        this.form.fromCommandsDate,
        this.form.toCommandsDate
      );
    },

    buildQuery() {
      return {
        fromDeadline: this.form.fromDeadline || undefined,
        toDeadline: this.form.toDeadline || undefined,
        fromCommandsDate: this.form.fromCommandsDate || undefined,
        toCommandsDate: this.form.toCommandsDate || undefined,
        directiveIds: this.form.directiveIds || undefined,
        performIds: this.form.performIds || undefined,
        sectors: this.form.sectors || undefined,
        commandStatusList: this.form.commandStatusList || undefined,
        progressStatus: this.form.progressStatus || undefined
      };
    },

    validate() {
      return new Promise(resolve => {
        resolve();
      });
    },

    storeParamsAtUrl() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: utils.merge(this.$route.query || {}, this.buildQuery())
      });
    },

    exportReportExcel() {
      this.storeParamsAtUrl();
      let query = utils.merge(this.form, {
        userDeptRoleId: this.userDeptRoleId
      });
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.REPORT.HC_COMMANDS.BAO_CAO_TONG_HOP_URL;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
        "_blank "
      );
    }
  }
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/report/hcCommands/hc-commands-report-index.vue